import { Features } from './common';
export var MemberShipType;
(function (MemberShipType) {
    MemberShipType["FREE"] = "Free";
    MemberShipType["PLUS"] = "Plus";
    MemberShipType["GOLD"] = "Legacy Gold";
    MemberShipType["PLATINUM"] = "Platinum";
    MemberShipType["SILVER"] = "Silver";
    MemberShipType["SERMON_SHARE"] = "Sermon Send";
    MemberShipType["SERMON_LIVE"] = "Sermon Live";
    MemberShipType["NEW_GOLD"] = "New Gold";
})(MemberShipType || (MemberShipType = {}));
export const PermissionsList = [
    {
        name: MemberShipType.FREE,
        values: [Features.CLIPS, Features.TRANSCRIPTION, Features.AUDIO]
    },
    {
        name: MemberShipType.PLUS,
        values: [Features.CLIPS, Features.TRANSCRIPTION, Features.AUDIO]
    },
    {
        name: MemberShipType.SILVER,
        values: [
            Features.CLIPS,
            Features.TRANSCRIPTION,
            Features.AUDIO,
            Features.DISCUSSION_GUIDE,
            Features.SUMMARY,
            Features.LIVESTREAM,
            Features.BLOG,
            Features.SERMON_SHARE,
            Features.CAROUSEL
        ]
    },
    {
        name: MemberShipType.GOLD,
        values: [
            Features.CLIPS,
            Features.TRANSCRIPTION,
            Features.AUDIO,
            Features.DISCUSSION_GUIDE,
            Features.SUMMARY,
            Features.LIVESTREAM,
            Features.SERMON_RECAP,
            Features.BLOG,
            Features.SERMON_SHARE,
            Features.CAROUSEL
        ]
    },
    {
        name: MemberShipType.NEW_GOLD,
        values: [
            Features.CLIPS,
            Features.TRANSCRIPTION,
            Features.AUDIO,
            Features.DISCUSSION_GUIDE,
            Features.SUMMARY,
            Features.LIVESTREAM,
            Features.SERMON_RECAP,
            Features.BLOG,
            Features.SERMON_SHARE,
            Features.CAROUSEL,
            Features.SERMON_LIVE
        ]
    },
    {
        name: MemberShipType.PLATINUM,
        values: [
            Features.CLIPS,
            Features.TRANSCRIPTION,
            Features.AUDIO,
            Features.DISCUSSION_GUIDE,
            Features.SUMMARY,
            Features.LIVESTREAM,
            Features.SERMON_RECAP,
            Features.BLOG,
            Features.SERMON_SHARE,
            Features.CAROUSEL,
            Features.SERMON_LIVE
        ]
    },
    {
        name: MemberShipType.SERMON_SHARE,
        values: [Features.SERMON_SHARE]
    },
    {
        name: MemberShipType.SERMON_LIVE,
        values: [Features.SERMON_LIVE]
    }
];
